import { ReportingPeriod } from '@nirvana/shared/dtos/types/shared/time';
import { longToNumber } from '@nirvana/shared/basic-types/long';
import { DashboardType } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { DisplayMode } from '../../types/common/types';

export function sanitizeReportingPeriod(reportingPeriod: ReportingPeriod | undefined): ReportingPeriod | undefined {
  if (!reportingPeriod) {
    // should we return a default value instead of undefined?
    return undefined;
  }

  return {
    current: {
      fromTimestamp: typeof reportingPeriod.current.fromTimestamp === 'object'
        ? longToNumber(reportingPeriod.current.fromTimestamp)
        : reportingPeriod.current.fromTimestamp,
      toTimestamp: typeof reportingPeriod.current.toTimestamp === 'object'
        ? longToNumber(reportingPeriod.current.toTimestamp)
        : reportingPeriod.current.toTimestamp,
    },
    previous: {
      fromTimestamp: typeof reportingPeriod.previous.fromTimestamp === 'object'
        ? longToNumber(reportingPeriod.previous.fromTimestamp)
        : reportingPeriod.previous.fromTimestamp,
      toTimestamp: typeof reportingPeriod.previous.toTimestamp === 'object'
        ? longToNumber(reportingPeriod.previous.toTimestamp)
        : reportingPeriod.previous.toTimestamp,
    },
    timeRange: reportingPeriod.timeRange
  };
}

export function getDisplayMode(): DisplayMode {
  const displayModeAttribute = (document.querySelector(
    `gz-generic-dashboard-app[data-dashboard-type="${DashboardType.EXECUTIVE_SUMMARY}`
  ) as HTMLElement | null)?.getAttribute('data-display-mode');

  return displayModeAttribute as DisplayMode || DisplayMode.DASHBOARD;
}
